import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PaymentCardsFlowType } from '@symphony-solo/domain/payment-cards/src/lib/enums/payment-cards-flow-type.enum';
import { WebsitePageNamesEnum } from '../enums';
import {
  openAddCardAction,
  openClickeAndCollectWebsiteAction,
  openPublicWebsitePageAction,
  openWebsitePageAction,
  pageOpenedAction,
} from './loyalty-website.actions';
import { ILoyaltyWebsiteFeature } from './loyalty-website.feature.state';
import { isLoading } from './loyalty-website.selectors';

@Injectable()
export class LoyaltyWebsiteFacade {
  public isLoading$ = this.store.select(isLoading);

  constructor(private store: Store<ILoyaltyWebsiteFeature>) {}

  public openWebsite(page: WebsitePageNamesEnum): void {
    this.store.dispatch(openWebsitePageAction({ pageName: page }));
  }

  public openClickAndCollect(): void {
    this.store.dispatch(openClickeAndCollectWebsiteAction());
  }

  public openAddCardFromLocationSelection(): void {
    this.store.dispatch(openAddCardAction({ flow: PaymentCardsFlowType.LocationSelection }));
  }

  public openAddCardFromSelectCard(): void {
    this.store.dispatch(openAddCardAction({ flow: PaymentCardsFlowType.SelectCard }));
  }

  public setPageOpened(): void {
    this.store.dispatch(pageOpenedAction());
  }

  // these are pages where you can navigate without being authenticated
  public openPublicWebsite(page: WebsitePageNamesEnum): void {
    this.store.dispatch(openPublicWebsitePageAction({ pageName: page }));
  }
}
